import { useEffect, useState } from 'react';
import api from '../services/api';

const POLL_MS = 15000;

export default function useEngagementCounts(enabled = true) {
  const [counts, setCounts] = useState({});

  useEffect(() => {
    if (!enabled) return undefined;
    const load = () =>
      api
        .summary()
        .then((d) => setCounts(d?.counts || {}))
        .catch(() => {});
    load();
    const t = setInterval(load, POLL_MS);
    return () => clearInterval(t);
  }, [enabled]);

  return counts;
}
